import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import * as types from './types';
import { fetchWishlist, addWishlistItem as _addWishlistItem, deleteWishlistItem as _deleteWishlistItem } from '~/services/wishlist';
export default {
  fetchWishlistItems: function () {
    var _fetchWishlistItems = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, _ref2, wishlist;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return fetchWishlist(this);

            case 3:
              _ref2 = _context.sent;
              wishlist = _ref2.wishlist;
              commit(types.SET_WISHLIST_ITEMS, wishlist);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchWishlistItems(_x) {
      return _fetchWishlistItems.apply(this, arguments);
    }

    return fetchWishlistItems;
  }(),
  addWishlistItem: function () {
    var _addWishlistItem2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref3, reference) {
      var commit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              commit(types.ADD_WISHLIST_ITEM, {
                product: {
                  reference: reference
                }
              });
              _context2.prev = 2;
              _context2.next = 5;
              return _addWishlistItem(this, reference);

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              console.log(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[2, 7]]);
    }));

    function addWishlistItem(_x2, _x3) {
      return _addWishlistItem2.apply(this, arguments);
    }

    return addWishlistItem;
  }(),
  deleteWishlistItem: function deleteWishlistItem(_ref4, reference) {
    var commit = _ref4.commit;
    commit(types.DELETE_WISHLIST_ITEM, reference);

    try {
      _deleteWishlistItem(this, reference);
    } catch (error) {
      console.log(error);
    }
  },
  fetchWishlistProducts: function () {
    var _fetchWishlistProducts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref5) {
      var commit, _ref6, wishlist;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;
              _context3.next = 3;
              return fetchWishlist(this, true);

            case 3:
              _ref6 = _context3.sent;
              wishlist = _ref6.wishlist;
              commit(types.SET_WISHLIST_PRODUCTS, wishlist);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetchWishlistProducts(_x4) {
      return _fetchWishlistProducts.apply(this, arguments);
    }

    return fetchWishlistProducts;
  }()
};